<template>
  <div :class="`ims-input-wrapper ${error === true ? 'input-error' : ''}`">
    <div @click="doFocus()" class="ims-input">
      <label v-if="label || placeholder">{{ label || placeholder }}</label>
      <div
        :class="
          `input-wrapper ${
            $slots.hasOwnProperty('right')
              ? 'd-flex row align-items-center'
              : ''
          }`
        "
      >
        <input
          ref="input"
          :autocomplete="shouldCorrect"
          :autocorrect="shouldCorrect"
          :autocapitalize="shouldCorrect"
          :spellcheck="autocomplete ? true : false"
          :type="type"
          :maxlength="maxlength"
          :disabled="disabled"
          v-on:input="emit"
          v-on:change="emit"
          v-on:focus="focus"
          v-on:blur="blur"
          v-model="innerValue"
          :placeholder="placeholder || label"
          v-if="
            ['text', 'password', 'number', 'email', 'phone'].indexOf(type) > -1
          "
        />
        <select
          :disabled="disabled"
          v-if="type == 'select'"
          v-model="innerValue"
          v-on:change="emit"
        >
          <slot />
        </select>
        <div class="right ml-2" v-if="$slots.hasOwnProperty('right')">
          <slot name="right" />
        </div>
      </div>
    </div>
    <div class="help" v-if="help">{{ help }}</div>
  </div>
</template>

<script>
import tick from '../../modules/tick/tick';
export default {
  data() {
    return {
      innerValue: null,
      focused: false
    };
  },
  computed: {
    shouldCorrect() {
      return this.autocomplete ? 'on' : 'off';
    }
  },
  methods: {
    doFocus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    focus() {
      if (!this.$slots.hasOwnProperty('right')) {
        this.focused = true;
      }
    },
    blur() {
      this.focused = false;
    },
    async emit() {
      this.$emit('input', this.innerValue);
      // Wait for a few seconds
      await tick(100);
      // force update
      this.$forceUpdate();
    }
  },
  props: {
    value: {
      default() {
        return '';
      }
    },
    maxlength: {
      type: Number,
      default() {
        return 255;
      }
    },
    error: {
      type: Boolean,
      default() {
        return false;
      }
    },
    autocomplete: {
      type: Boolean,
      default() {
        return true;
      }
    },
    type: {
      type: String,
      default() {
        return 'text';
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    label: {},
    help: {},
    placeholder: {
      type: String,
      default() {
        return null;
      }
    },
    required: {
      type: Boolean,
      default() {
        return false;
      }
    },
    inputClass: {
      default() {
        return '';
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.innerValue = val;
      }
    }
  },
  mounted() {
    this.innerValue = this.value;
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';

.ims-input-wrapper {
  .help {
    font-size: 0.7rem;
    opacity: 0.6;
    margin-top: -5px;
    padding-left: 6px;
  }
  &.input-error {
    label {
      color: $red;
    }
    border-bottom: solid 1px $red;
  }
}
// Updated / Simplier IMS-Input
/**.help
We were having issues with older chrome and safari 
and input event changes. In efforts to get things done we're scrapping the nice looking inputs
and going with traditional inputs
 */
.ims-input {
  padding: 10px 0;

  label {
    display: block;
    line-height: 120%;
    padding: 0;
    margin-bottom: 6px;
    font-size: 0.7rem;
    text-transform: uppercase;
    font-weight: bold;
    opacity: 0.6;
  }
  &.dark {
    background-color: $gray-900;
    color: #fff;
    input {
      color: #fff;
    }
    label {
      color: rgba(255, 255, 255, 0.5);
    }
  }
  input,
  select {
    display: block;
    flex-grow: 1;
    width: 100%;
    font-size: 1rem;
    padding: 6px 10px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    &:disabled {
      opacity: 0.9;
    }
  }
}
// .ims-input {
//   cursor: pointer;
//   border-radius: 4px;
//   min-height: 46px;
//   height: 46px;
//   border: solid 1px rgba(0, 0, 0, 0.2);
//   display: flex;
//   flex-direction: row;
//   position: relative;
//   align-items: center;
//   padding: 6px 10px;
//   line-height: 22px;
//   transition: all 0.2s ease-in-out;
//   background-color: #fff;
//   margin-bottom: 12px;
//   width: 100%;

//   &.dark {
//     background-color: $gray-900;
//     color: #fff;
//     input {
//       color: #fff;
//     }
//     label {
//       color: rgba(255, 255, 255, 0.5);
//     }
//   }

//   select {
//     flex-grow: 1;
//     max-width: calc(100% - 20px);
//   }
//   &.type-select {
//     position: relative;
//     &:after {
//       content: '▼';
//       position: absolute;
//       right: 16px;
//       color: rgba(0, 0, 0, 0.45);
//       font-size: $font-sm;
//     }
//   }

//   &:before {
//     transition: all 0.2s ease-in-out;
//     content: '';
//     position: absolute;
//     top: 2px;
//     right: 2px;
//     bottom: 2px;
//     width: 4px;
//     border-radius: 2px;
//   }

//   &.is-required {
//     position: relative;
//     &.no-input {
//       &:before {
//         background-color: red;
//         opacity: 0.2;
//       }
//     }
//   }

//   &.has-error {
//     position: relative;
//     &:before {
//       background-color: red;
//       opacity: 1;
//     }
//   }

//   // Default and Hidden Label Settings
//   label {
//     transition: all 0.2s ease-in-out;
//     pointer-events: none;
//     transform: translateY(20px);
//     opacity: 0;
//     position: absolute;
//     top: 3px;
//     left: 10px;
//     font-size: 0.6rem;
//     line-height: 16px;
//     color: rgba(0, 0, 0, 0.6);
//     text-transform: uppercase;
//   }
//   input[type] {
//     // margin-top: -4px;
//     border: none !important;
//     &:focus {
//       outline: none !important;
//     }
//     background-color: transparent;
//     width: 100%;
//     padding-left: 0;
//   }

//   select {
//     display: block;
//     max-width: 100%;
//     padding-right: 20px;
//     -webkit-appearance: none;
//     padding-left: 0;
//     border: none;
//     background: transparent;
//     &:focus {
//       outline: none !important;
//     }
//   }

//   &.has-error {
//     &:before {
//       background-color: $red !important;
//       opacity: 0.9 !important;
//     }
//   }

//   &.has-input {
//     position: relative;
//     padding-bottom: 4px;
//     &.ims-select {
//       padding: 0px 2px 0px 10px !important;
//     }
//     &.is-required {
//       &:before {
//         opacity: 0.2;
//       }
//     }
//     label {
//       transform: translateY(-2px);
//       z-index: 100;
//       opacity: 1;
//     }

//     select {
//       z-index: 10;
//       margin-top: 8px;
//     }
//     input[type],
//     input[type='email'],
//     input[type='password'],
//     input[type='number'],
//     input[password] {
//       z-index: 10;
//       margin-top: 12px;
//     }
//     &.ims-input-no-label {
//       input[type] {
//         margin-top: 6px;
//       }
//     }
//   } // end has-input

//   &.focused {
//     border: solid 1px rgba($primary, 0.6);
//     box-shadow: 0px 6px 12px -4px rgba($primary, 0.1);
//   }

//   &.ims-input-select {
//     &:after {
//       content: '';
//       width: 0;
//       height: 0;
//       border-left: 6px solid transparent;
//       border-right: 6px solid transparent;
//       border-top: 6px solid #777;
//       position: absolute;
//       right: 10px;
//       top: calc(50% - 3px);
//       bottom: 0;
//     }
//   }
// }

.ims-item {
  padding: 6px 16px;
}

.ims-radio {
  width: 28px;
  height: 28px;
}
</style>
